import Axios from 'axios'
import store from '../store'

// const baseURL = config.VUE_APP_API_BASE_URL
const baseURL = store.getters.getCompany.baseUrl

const axiosConfig = Axios.create({
  baseURL: baseURL,
  headers: {
    'Authorization': store.getters.getCompany.token,
    'Content-Type': 'application/json'
  }
})

export default axiosConfig
